import { createSelector } from 'reselect';
import unescapedText from 'I18n/utils/unescapedText';
import { getPortalInstanceId } from './previewSelectors';
const I18nKey = key => `theme-previewer.states.${key}`;
export const isPortalMode = createSelector(getPortalInstanceId, portalInstanceId => !!portalInstanceId);
export const getPortalInstances = state => {
  var _state$preview;
  return ((_state$preview = state.preview) === null || _state$preview === void 0 ? void 0 : _state$preview.portalInstances) || [];
};
export const getSelectedPortalInstanceId = state => {
  var _state$preview2;
  return (_state$preview2 = state.preview) === null || _state$preview2 === void 0 ? void 0 : _state$preview2.selectedPortalInstanceId;
};
export const getPortalInstancesRequestStatus = state => {
  var _state$preview3;
  return (_state$preview3 = state.preview) === null || _state$preview3 === void 0 ? void 0 : _state$preview3.portalInstancesRequestStatus;
};

// Transform Portal list into grouped dropdown options
export const getGroupedPortalOptions = createSelector([getPortalInstances], portals => {
  // Group by type
  const portalsByType = portals.reduce((acc, portal) => {
    const type = portal.portalInstanceType;
    if (!acc[type]) acc[type] = [];
    acc[type].push(portal);
    return acc;
  }, {});
  const listItemOrder = ['REFERENCE', 'CUSTOMER', 'CUSTOMER_SUCCESS', 'BUYER', 'BILLING', 'DEAL_PLAN'];

  // Create groups (only include non-empty groups)
  return listItemOrder.filter(type => {
    var _portalsByType$type;
    return ((_portalsByType$type = portalsByType[type]) === null || _portalsByType$type === void 0 ? void 0 : _portalsByType$type.length) > 0;
  }).map(type => {
    const options = portalsByType[type].map(portal => ({
      text: portal.displayName || portal.internalName,
      value: portal.id,
      help: `${portal.domain}/${portal.slug}`,
      portal
    })).sort((a, b) => a.text.localeCompare(b.text));
    return {
      state: `${String(type)}_PORTALS`,
      disableLinks: false,
      disabledMessage: undefined,
      options,
      text: unescapedText(I18nKey(`${String(type)}_PORTALS`), {
        count: options.length
      })
    };
  });
});